// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media screen and (max-height: 850px) {
.add-dialog-content {
    max-height: 480px;
}
}
.add-dialog-content {
  overflow-y: auto;
}
.v-dialog .v-card {
  background: #fafafa !important;
}
.v-list {
  padding: 0 !important;
}
.v-btn-floating {
  margin: 6px 0;
}
.v-toolbar__title {
  line-height: 1.3;
}
.drainage-img,
.si-img {
  width: 20px;
  height: 20px;
  position: relative;
  top: 2px;
  overflow: hidden;
}
.v-dialog .v-card .v-card__actions .btn-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.v-dialog .v-card .v-card__actions .btn-wrap:last-child {
  justify-content: flex-end;
}
.he-wizard-frame {
  display: block;
  max-width: 1000px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

/* Hides the He-Wizard when a duplicate job in open in the partial job view */
.v-dialog__content--active:has(> .hide-wizard-dialog-wrapper) {
  z-index: -1000 !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
